module.exports = __webpack_public_path__ + "assets/img/Type BS (20).c3597815.jpg";